// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file live178/v1/sports.proto (package live178.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { OperationResult, PageRequest, PageResponse, RequestMetadata } from "./common_pb";
import { file_live178_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file live178/v1/sports.proto.
 */
export const file_live178_v1_sports: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_live178_v1_common]);

/**
 * @generated from message live178.v1.Team
 */
export type Team = Message<"live178.v1.Team"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string short_name = 3;
   */
  shortName: string;

  /**
   * @generated from field: string logo_url = 4;
   */
  logoUrl: string;

  /**
   * @generated from field: string country_code = 5;
   */
  countryCode: string;
};

/**
 * Describes the message live178.v1.Team.
 * Use `create(TeamSchema)` to create a new message.
 */
export const TeamSchema: GenMessage<Team> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 0);

/**
 * @generated from message live178.v1.Competition
 */
export type Competition = Message<"live178.v1.Competition"> & {
  /**
   * @generated from field: string competition_id = 1;
   */
  competitionId: string;

  /**
   * @generated from field: live178.v1.SportType sport = 2;
   */
  sport: SportType;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string logo_url = 4;
   */
  logoUrl: string;

  /**
   * @generated from field: string country_code = 5;
   */
  countryCode: string;

  /**
   * @generated from field: int32 display_order = 6;
   */
  displayOrder: number;
};

/**
 * Describes the message live178.v1.Competition.
 * Use `create(CompetitionSchema)` to create a new message.
 */
export const CompetitionSchema: GenMessage<Competition> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 1);

/**
 * @generated from message live178.v1.MatchScore
 */
export type MatchScore = Message<"live178.v1.MatchScore"> & {
  /**
   * @generated from field: int32 home = 1;
   */
  home: number;

  /**
   * @generated from field: int32 away = 2;
   */
  away: number;

  /**
   * @generated from field: int32 home_period = 3;
   */
  homePeriod: number;

  /**
   * @generated from field: int32 away_period = 4;
   */
  awayPeriod: number;

  /**
   * @generated from field: string display = 5;
   */
  display: string;
};

/**
 * Describes the message live178.v1.MatchScore.
 * Use `create(MatchScoreSchema)` to create a new message.
 */
export const MatchScoreSchema: GenMessage<MatchScore> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 2);

/**
 * @generated from message live178.v1.Match
 */
export type Match = Message<"live178.v1.Match"> & {
  /**
   * @generated from field: string match_id = 1;
   */
  matchId: string;

  /**
   * @generated from field: live178.v1.SportType sport = 2;
   */
  sport: SportType;

  /**
   * @generated from field: live178.v1.Competition competition = 3;
   */
  competition?: Competition | undefined;

  /**
   * @generated from field: live178.v1.Team home_team = 4;
   */
  homeTeam?: Team | undefined;

  /**
   * @generated from field: live178.v1.Team away_team = 5;
   */
  awayTeam?: Team | undefined;

  /**
   * @generated from field: live178.v1.MatchStatus status = 6;
   */
  status: MatchStatus;

  /**
   * @generated from field: live178.v1.MatchScore score = 7;
   */
  score?: MatchScore | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_at = 8;
   */
  scheduledAt?: Timestamp | undefined;

  /**
   * @generated from field: int32 clock_seconds = 9;
   */
  clockSeconds: number;

  /**
   * @generated from field: int64 revision = 10;
   */
  revision: bigint;

  /**
   * @generated from field: bool followed = 11;
   */
  followed: boolean;

  /**
   * @generated from field: bool has_live_room = 12;
   */
  hasLiveRoom: boolean;

  /**
   * @generated from field: string live_room_id = 13;
   */
  liveRoomId: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.Match.
 * Use `create(MatchSchema)` to create a new message.
 */
export const MatchSchema: GenMessage<Match> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 3);

/**
 * @generated from message live178.v1.MatchEvent
 */
export type MatchEvent = Message<"live178.v1.MatchEvent"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: string match_id = 2;
   */
  matchId: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: string team_id = 4;
   */
  teamId: string;

  /**
   * @generated from field: string player_id = 5;
   */
  playerId: string;

  /**
   * @generated from field: string player_name = 6;
   */
  playerName: string;

  /**
   * @generated from field: int32 period = 7;
   */
  period: number;

  /**
   * @generated from field: int32 clock_seconds = 8;
   */
  clockSeconds: number;

  /**
   * @generated from field: string description = 9;
   */
  description: string;

  /**
   * @generated from field: int64 revision = 10;
   */
  revision: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 11;
   */
  occurredAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.MatchEvent.
 * Use `create(MatchEventSchema)` to create a new message.
 */
export const MatchEventSchema: GenMessage<MatchEvent> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 4);

/**
 * @generated from message live178.v1.MatchStatistic
 */
export type MatchStatistic = Message<"live178.v1.MatchStatistic"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string home_value = 3;
   */
  homeValue: string;

  /**
   * @generated from field: string away_value = 4;
   */
  awayValue: string;

  /**
   * @generated from field: int32 display_order = 5;
   */
  displayOrder: number;
};

/**
 * Describes the message live178.v1.MatchStatistic.
 * Use `create(MatchStatisticSchema)` to create a new message.
 */
export const MatchStatisticSchema: GenMessage<MatchStatistic> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 5);

/**
 * @generated from message live178.v1.LineupPlayer
 */
export type LineupPlayer = Message<"live178.v1.LineupPlayer"> & {
  /**
   * @generated from field: string player_id = 1;
   */
  playerId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId: string;

  /**
   * @generated from field: string position = 4;
   */
  position: string;

  /**
   * @generated from field: int32 shirt_number = 5;
   */
  shirtNumber: number;

  /**
   * @generated from field: bool starter = 6;
   */
  starter: boolean;
};

/**
 * Describes the message live178.v1.LineupPlayer.
 * Use `create(LineupPlayerSchema)` to create a new message.
 */
export const LineupPlayerSchema: GenMessage<LineupPlayer> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 6);

/**
 * @generated from message live178.v1.StandingRow
 */
export type StandingRow = Message<"live178.v1.StandingRow"> & {
  /**
   * @generated from field: int32 position = 1;
   */
  position: number;

  /**
   * @generated from field: live178.v1.Team team = 2;
   */
  team?: Team | undefined;

  /**
   * @generated from field: int32 played = 3;
   */
  played: number;

  /**
   * @generated from field: int32 won = 4;
   */
  won: number;

  /**
   * @generated from field: int32 drawn = 5;
   */
  drawn: number;

  /**
   * @generated from field: int32 lost = 6;
   */
  lost: number;

  /**
   * @generated from field: int32 points = 7;
   */
  points: number;

  /**
   * @generated from field: int32 score_for = 8;
   */
  scoreFor: number;

  /**
   * @generated from field: int32 score_against = 9;
   */
  scoreAgainst: number;
};

/**
 * Describes the message live178.v1.StandingRow.
 * Use `create(StandingRowSchema)` to create a new message.
 */
export const StandingRowSchema: GenMessage<StandingRow> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 7);

/**
 * @generated from message live178.v1.ListMatchesRequest
 */
export type ListMatchesRequest = Message<"live178.v1.ListMatchesRequest"> & {
  /**
   * @generated from field: live178.v1.SportType sport = 1;
   */
  sport: SportType;

  /**
   * @generated from field: string local_date = 2;
   */
  localDate: string;

  /**
   * @generated from field: live178.v1.MatchStatus status = 3;
   */
  status: MatchStatus;

  /**
   * @generated from field: repeated string competition_ids = 4;
   */
  competitionIds: string[];

  /**
   * @generated from field: bool followed_only = 5;
   */
  followedOnly: boolean;

  /**
   * @generated from field: live178.v1.PageRequest page = 6;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListMatchesRequest.
 * Use `create(ListMatchesRequestSchema)` to create a new message.
 */
export const ListMatchesRequestSchema: GenMessage<ListMatchesRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 8);

/**
 * @generated from message live178.v1.ListMatchesResponse
 */
export type ListMatchesResponse = Message<"live178.v1.ListMatchesResponse"> & {
  /**
   * @generated from field: repeated live178.v1.Match matches = 1;
   */
  matches: Match[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;

  /**
   * @generated from field: live178.v1.RequestMetadata metadata = 3;
   */
  metadata?: RequestMetadata | undefined;
};

/**
 * Describes the message live178.v1.ListMatchesResponse.
 * Use `create(ListMatchesResponseSchema)` to create a new message.
 */
export const ListMatchesResponseSchema: GenMessage<ListMatchesResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 9);

/**
 * @generated from message live178.v1.GetMatchRequest
 */
export type GetMatchRequest = Message<"live178.v1.GetMatchRequest"> & {
  /**
   * @generated from field: string match_id = 1;
   */
  matchId: string;
};

/**
 * Describes the message live178.v1.GetMatchRequest.
 * Use `create(GetMatchRequestSchema)` to create a new message.
 */
export const GetMatchRequestSchema: GenMessage<GetMatchRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 10);

/**
 * @generated from message live178.v1.GetMatchResponse
 */
export type GetMatchResponse = Message<"live178.v1.GetMatchResponse"> & {
  /**
   * @generated from field: live178.v1.Match match = 1;
   */
  match?: Match | undefined;

  /**
   * @generated from field: repeated live178.v1.MatchEvent events = 2;
   */
  events: MatchEvent[];

  /**
   * @generated from field: repeated live178.v1.MatchStatistic statistics = 3;
   */
  statistics: MatchStatistic[];

  /**
   * @generated from field: repeated live178.v1.LineupPlayer lineup = 4;
   */
  lineup: LineupPlayer[];

  /**
   * @generated from field: live178.v1.RequestMetadata metadata = 5;
   */
  metadata?: RequestMetadata | undefined;
};

/**
 * Describes the message live178.v1.GetMatchResponse.
 * Use `create(GetMatchResponseSchema)` to create a new message.
 */
export const GetMatchResponseSchema: GenMessage<GetMatchResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 11);

/**
 * @generated from message live178.v1.FollowMatchRequest
 */
export type FollowMatchRequest = Message<"live178.v1.FollowMatchRequest"> & {
  /**
   * @generated from field: string match_id = 1;
   */
  matchId: string;

  /**
   * @generated from field: bool followed = 2;
   */
  followed: boolean;
};

/**
 * Describes the message live178.v1.FollowMatchRequest.
 * Use `create(FollowMatchRequestSchema)` to create a new message.
 */
export const FollowMatchRequestSchema: GenMessage<FollowMatchRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 12);

/**
 * @generated from message live178.v1.FollowMatchResponse
 */
export type FollowMatchResponse = Message<"live178.v1.FollowMatchResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.FollowMatchResponse.
 * Use `create(FollowMatchResponseSchema)` to create a new message.
 */
export const FollowMatchResponseSchema: GenMessage<FollowMatchResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 13);

/**
 * @generated from message live178.v1.ListCompetitionsRequest
 */
export type ListCompetitionsRequest = Message<"live178.v1.ListCompetitionsRequest"> & {
  /**
   * @generated from field: live178.v1.SportType sport = 1;
   */
  sport: SportType;

  /**
   * @generated from field: live178.v1.PageRequest page = 2;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListCompetitionsRequest.
 * Use `create(ListCompetitionsRequestSchema)` to create a new message.
 */
export const ListCompetitionsRequestSchema: GenMessage<ListCompetitionsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 14);

/**
 * @generated from message live178.v1.ListCompetitionsResponse
 */
export type ListCompetitionsResponse = Message<"live178.v1.ListCompetitionsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.Competition competitions = 1;
   */
  competitions: Competition[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListCompetitionsResponse.
 * Use `create(ListCompetitionsResponseSchema)` to create a new message.
 */
export const ListCompetitionsResponseSchema: GenMessage<ListCompetitionsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 15);

/**
 * @generated from message live178.v1.GetStandingsRequest
 */
export type GetStandingsRequest = Message<"live178.v1.GetStandingsRequest"> & {
  /**
   * @generated from field: string competition_id = 1;
   */
  competitionId: string;

  /**
   * @generated from field: string season_id = 2;
   */
  seasonId: string;
};

/**
 * Describes the message live178.v1.GetStandingsRequest.
 * Use `create(GetStandingsRequestSchema)` to create a new message.
 */
export const GetStandingsRequestSchema: GenMessage<GetStandingsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 16);

/**
 * @generated from message live178.v1.GetStandingsResponse
 */
export type GetStandingsResponse = Message<"live178.v1.GetStandingsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.StandingRow rows = 1;
   */
  rows: StandingRow[];

  /**
   * @generated from field: int64 revision = 2;
   */
  revision: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.GetStandingsResponse.
 * Use `create(GetStandingsResponseSchema)` to create a new message.
 */
export const GetStandingsResponseSchema: GenMessage<GetStandingsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 17);

/**
 * @generated from message live178.v1.PlayerRankingRow
 */
export type PlayerRankingRow = Message<"live178.v1.PlayerRankingRow"> & {
  /**
   * @generated from field: int32 position = 1;
   */
  position: number;

  /**
   * @generated from field: string player_id = 2;
   */
  playerId: string;

  /**
   * @generated from field: string player_name = 3;
   */
  playerName: string;

  /**
   * @generated from field: live178.v1.Team team = 4;
   */
  team?: Team | undefined;

  /**
   * @generated from field: int32 appearances = 5;
   */
  appearances: number;

  /**
   * @generated from field: int32 goals = 6;
   */
  goals: number;

  /**
   * @generated from field: int32 assists = 7;
   */
  assists: number;
};

/**
 * Describes the message live178.v1.PlayerRankingRow.
 * Use `create(PlayerRankingRowSchema)` to create a new message.
 */
export const PlayerRankingRowSchema: GenMessage<PlayerRankingRow> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 18);

/**
 * @generated from message live178.v1.GetPlayerRankingsRequest
 */
export type GetPlayerRankingsRequest = Message<"live178.v1.GetPlayerRankingsRequest"> & {
  /**
   * @generated from field: string competition_id = 1;
   */
  competitionId: string;

  /**
   * @generated from field: string season_id = 2;
   */
  seasonId: string;

  /**
   * @generated from field: string metric = 3;
   */
  metric: string;

  /**
   * @generated from field: live178.v1.PageRequest page = 4;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.GetPlayerRankingsRequest.
 * Use `create(GetPlayerRankingsRequestSchema)` to create a new message.
 */
export const GetPlayerRankingsRequestSchema: GenMessage<GetPlayerRankingsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 19);

/**
 * @generated from message live178.v1.GetPlayerRankingsResponse
 */
export type GetPlayerRankingsResponse = Message<"live178.v1.GetPlayerRankingsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.PlayerRankingRow rows = 1;
   */
  rows: PlayerRankingRow[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;

  /**
   * @generated from field: int64 revision = 3;
   */
  revision: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.GetPlayerRankingsResponse.
 * Use `create(GetPlayerRankingsResponseSchema)` to create a new message.
 */
export const GetPlayerRankingsResponseSchema: GenMessage<GetPlayerRankingsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 20);

/**
 * @generated from message live178.v1.ProviderMatchUpdate
 */
export type ProviderMatchUpdate = Message<"live178.v1.ProviderMatchUpdate"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string provider_match_id = 2;
   */
  providerMatchId: string;

  /**
   * @generated from field: string raw_version = 3;
   */
  rawVersion: string;

  /**
   * @generated from field: google.protobuf.Timestamp provider_updated_at = 4;
   */
  providerUpdatedAt?: Timestamp | undefined;

  /**
   * @generated from field: live178.v1.Match normalized_match = 5;
   */
  normalizedMatch?: Match | undefined;

  /**
   * @generated from field: repeated live178.v1.MatchEvent events = 6;
   */
  events: MatchEvent[];
};

/**
 * Describes the message live178.v1.ProviderMatchUpdate.
 * Use `create(ProviderMatchUpdateSchema)` to create a new message.
 */
export const ProviderMatchUpdateSchema: GenMessage<ProviderMatchUpdate> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 21);

/**
 * @generated from message live178.v1.IngestProviderMatchRequest
 */
export type IngestProviderMatchRequest = Message<"live178.v1.IngestProviderMatchRequest"> & {
  /**
   * @generated from field: live178.v1.ProviderMatchUpdate update = 1;
   */
  update?: ProviderMatchUpdate | undefined;
};

/**
 * Describes the message live178.v1.IngestProviderMatchRequest.
 * Use `create(IngestProviderMatchRequestSchema)` to create a new message.
 */
export const IngestProviderMatchRequestSchema: GenMessage<IngestProviderMatchRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 22);

/**
 * @generated from message live178.v1.IngestProviderMatchResponse
 */
export type IngestProviderMatchResponse = Message<"live178.v1.IngestProviderMatchResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.IngestProviderMatchResponse.
 * Use `create(IngestProviderMatchResponseSchema)` to create a new message.
 */
export const IngestProviderMatchResponseSchema: GenMessage<IngestProviderMatchResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 23);

/**
 * ManagedMatch is the administrator projection of a match. Unlike the public
 * schedule API it includes every status, including scheduled, postponed,
 * cancelled and finished records.
 *
 * @generated from message live178.v1.ManagedMatch
 */
export type ManagedMatch = Message<"live178.v1.ManagedMatch"> & {
  /**
   * @generated from field: live178.v1.Match match = 1;
   */
  match?: Match | undefined;

  /**
   * @generated from field: bool manually_edited = 2;
   */
  manuallyEdited: boolean;

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp override_updated_at = 4;
   */
  overrideUpdatedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.ManagedMatch.
 * Use `create(ManagedMatchSchema)` to create a new message.
 */
export const ManagedMatchSchema: GenMessage<ManagedMatch> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 24);

/**
 * @generated from message live178.v1.ListManagedMatchesRequest
 */
export type ListManagedMatchesRequest = Message<"live178.v1.ListManagedMatchesRequest"> & {
  /**
   * @generated from field: live178.v1.SportType sport = 1;
   */
  sport: SportType;

  /**
   * @generated from field: live178.v1.MatchStatus status = 2;
   */
  status: MatchStatus;

  /**
   * @generated from field: string query = 3;
   */
  query: string;

  /**
   * @generated from field: live178.v1.PageRequest page = 4;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListManagedMatchesRequest.
 * Use `create(ListManagedMatchesRequestSchema)` to create a new message.
 */
export const ListManagedMatchesRequestSchema: GenMessage<ListManagedMatchesRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 25);

/**
 * @generated from message live178.v1.ListManagedMatchesResponse
 */
export type ListManagedMatchesResponse = Message<"live178.v1.ListManagedMatchesResponse"> & {
  /**
   * @generated from field: repeated live178.v1.ManagedMatch items = 1;
   */
  items: ManagedMatch[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;

  /**
   * @generated from field: live178.v1.RequestMetadata metadata = 3;
   */
  metadata?: RequestMetadata | undefined;
};

/**
 * Describes the message live178.v1.ListManagedMatchesResponse.
 * Use `create(ListManagedMatchesResponseSchema)` to create a new message.
 */
export const ListManagedMatchesResponseSchema: GenMessage<ListManagedMatchesResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 26);

/**
 * @generated from message live178.v1.UpdateManagedMatchRequest
 */
export type UpdateManagedMatchRequest = Message<"live178.v1.UpdateManagedMatchRequest"> & {
  /**
   * @generated from field: live178.v1.Match match = 1;
   */
  match?: Match | undefined;

  /**
   * @generated from field: int64 expected_revision = 2;
   */
  expectedRevision: bigint;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.UpdateManagedMatchRequest.
 * Use `create(UpdateManagedMatchRequestSchema)` to create a new message.
 */
export const UpdateManagedMatchRequestSchema: GenMessage<UpdateManagedMatchRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 27);

/**
 * @generated from message live178.v1.UpdateManagedMatchResponse
 */
export type UpdateManagedMatchResponse = Message<"live178.v1.UpdateManagedMatchResponse"> & {
  /**
   * @generated from field: live178.v1.ManagedMatch item = 1;
   */
  item?: ManagedMatch | undefined;
};

/**
 * Describes the message live178.v1.UpdateManagedMatchResponse.
 * Use `create(UpdateManagedMatchResponseSchema)` to create a new message.
 */
export const UpdateManagedMatchResponseSchema: GenMessage<UpdateManagedMatchResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 28);

/**
 * @generated from message live178.v1.ResetManagedMatchRequest
 */
export type ResetManagedMatchRequest = Message<"live178.v1.ResetManagedMatchRequest"> & {
  /**
   * @generated from field: string match_id = 1;
   */
  matchId: string;

  /**
   * @generated from field: int64 expected_revision = 2;
   */
  expectedRevision: bigint;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.ResetManagedMatchRequest.
 * Use `create(ResetManagedMatchRequestSchema)` to create a new message.
 */
export const ResetManagedMatchRequestSchema: GenMessage<ResetManagedMatchRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 29);

/**
 * @generated from message live178.v1.ResetManagedMatchResponse
 */
export type ResetManagedMatchResponse = Message<"live178.v1.ResetManagedMatchResponse"> & {
  /**
   * @generated from field: live178.v1.ManagedMatch item = 1;
   */
  item?: ManagedMatch | undefined;
};

/**
 * Describes the message live178.v1.ResetManagedMatchResponse.
 * Use `create(ResetManagedMatchResponseSchema)` to create a new message.
 */
export const ResetManagedMatchResponseSchema: GenMessage<ResetManagedMatchResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_sports, 30);

/**
 * @generated from enum live178.v1.SportType
 */
export enum SportType {
  /**
   * @generated from enum value: SPORT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SPORT_TYPE_FOOTBALL = 1;
   */
  FOOTBALL = 1,

  /**
   * @generated from enum value: SPORT_TYPE_BASKETBALL = 2;
   */
  BASKETBALL = 2,
}

/**
 * Describes the enum live178.v1.SportType.
 */
export const SportTypeSchema: GenEnum<SportType> = /*@__PURE__*/
  enumDesc(file_live178_v1_sports, 0);

/**
 * @generated from enum live178.v1.MatchStatus
 */
export enum MatchStatus {
  /**
   * @generated from enum value: MATCH_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MATCH_STATUS_SCHEDULED = 1;
   */
  SCHEDULED = 1,

  /**
   * @generated from enum value: MATCH_STATUS_LIVE = 2;
   */
  LIVE = 2,

  /**
   * @generated from enum value: MATCH_STATUS_HALFTIME = 3;
   */
  HALFTIME = 3,

  /**
   * @generated from enum value: MATCH_STATUS_SUSPENDED = 4;
   */
  SUSPENDED = 4,

  /**
   * @generated from enum value: MATCH_STATUS_FINISHED = 5;
   */
  FINISHED = 5,

  /**
   * @generated from enum value: MATCH_STATUS_POSTPONED = 6;
   */
  POSTPONED = 6,

  /**
   * @generated from enum value: MATCH_STATUS_CANCELLED = 7;
   */
  CANCELLED = 7,
}

/**
 * Describes the enum live178.v1.MatchStatus.
 */
export const MatchStatusSchema: GenEnum<MatchStatus> = /*@__PURE__*/
  enumDesc(file_live178_v1_sports, 1);

/**
 * @generated from service live178.v1.SportsService
 */
export const SportsService: GenService<{
  /**
   * @generated from rpc live178.v1.SportsService.ListMatches
   */
  listMatches: {
    methodKind: "unary";
    input: typeof ListMatchesRequestSchema;
    output: typeof ListMatchesResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.SportsService.GetMatch
   */
  getMatch: {
    methodKind: "unary";
    input: typeof GetMatchRequestSchema;
    output: typeof GetMatchResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.SportsService.FollowMatch
   */
  followMatch: {
    methodKind: "unary";
    input: typeof FollowMatchRequestSchema;
    output: typeof FollowMatchResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.SportsService.ListCompetitions
   */
  listCompetitions: {
    methodKind: "unary";
    input: typeof ListCompetitionsRequestSchema;
    output: typeof ListCompetitionsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.SportsService.GetStandings
   */
  getStandings: {
    methodKind: "unary";
    input: typeof GetStandingsRequestSchema;
    output: typeof GetStandingsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.SportsService.GetPlayerRankings
   */
  getPlayerRankings: {
    methodKind: "unary";
    input: typeof GetPlayerRankingsRequestSchema;
    output: typeof GetPlayerRankingsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.SportsService.IngestProviderMatch
   */
  ingestProviderMatch: {
    methodKind: "unary";
    input: typeof IngestProviderMatchRequestSchema;
    output: typeof IngestProviderMatchResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.SportsService.ListManagedMatches
   */
  listManagedMatches: {
    methodKind: "unary";
    input: typeof ListManagedMatchesRequestSchema;
    output: typeof ListManagedMatchesResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.SportsService.UpdateManagedMatch
   */
  updateManagedMatch: {
    methodKind: "unary";
    input: typeof UpdateManagedMatchRequestSchema;
    output: typeof UpdateManagedMatchResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.SportsService.ResetManagedMatch
   */
  resetManagedMatch: {
    methodKind: "unary";
    input: typeof ResetManagedMatchRequestSchema;
    output: typeof ResetManagedMatchResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_live178_v1_sports, 0);

